module.exports = __webpack_public_path__ + "vendor/fontawesome-webfont_fee66e71.woff";


//////////////////
// WEBPACK FOOTER
// /Users/eulo/repos/CodeDrips/round3/wp-content/themes/round3/node_modules/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 87
// module chunks = 0